import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import './ConsentFormWithData.css'; // Import the CSS file
import i18next from 'i18next';

function ConsentFormWithData({ t, i18n, data, setData, setConsentSubmitted, setErrorMessage }) {
  const [isEditable, setIsEditable] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    data = {...data, firstName: data.firstName.trim(), lastName: data.lastName.trim()};
    try {
      await axios.post(process.env.REACT_APP_API_URL + `/qr/info/contact/STI%23` + encodeURIComponent(id), data, {timeout: 30000});
      setConsentSubmitted(true);
    } catch (error) {
      console.error('API call failed:', error);
      setErrorMessage(t("error.updating"));
      setConsentSubmitted(false);
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="consent-form">
        <div className="edit-link">
          {!isEditable && (
            <button type="button" onClick={() => setIsEditable(true)} className="link-button">
              {t("button.edit")}
            </button>
          )}
        </div>
        <label>
          {t("first_name")}:
          <input type="text" name="firstName" value={data.firstName} onChange={handleChange} disabled={!isEditable} />
        </label>
        <label>
          {t("last_name")}:
          <input type="text" name="lastName" value={data.lastName} onChange={handleChange} disabled={!isEditable} />
        </label>
        <div>
          <input type="checkbox" id="consent" name="consent" checked={data.consent} onChange={handleChange} />
          <label htmlFor="consent">{t("consent")}</label>
        </div>
        <label align="center">
          <a href={"https://www.thermovault.com/" + i18next.language + "/terms-conditions"} target="_blank" rel="noopener noreferrer">
            {t("terms_and_conditions")}
          </a>
          <br />
          <a href={"https://www.thermovault.com/" + i18next.language + "/privacy-policy"} target="_blank" rel="noopener noreferrer">
            {t("privacy_policy")}
          </a>
        </label>
        <button type="submit" disabled={!data.consent || data.firstName === "" || data.lastName === ""}>{t("button.submit")}</button>
      </form>
    </div>
  );
}

export default withTranslation()(ConsentFormWithData);
